
















import './KisweDateRangeSelector.scss'
import { DatePicker } from 'element-ui'
import { defineComponent, computed } from '@vue/composition-api'
import { KisweDisabledDate } from '@/modules/kisweui/types'
import KisweIcon from '../KisweIcon'
import KisweDate from '@/modules/common/classes/KisweDate'

export default defineComponent({
  name: 'KisweDateRangeSelector',
  components: {
    'el-date-picker': DatePicker,
    KisweIcon
  },
  props: {
    format: {
      type: String,
      required: false,
      default: 'MM/dd/yy'
    },
    disabledDate: {
      type: String as () => KisweDisabledDate,
      default: KisweDisabledDate.None
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    value: {
      type: Array as () => Date[],
      required: false,
      default: () => [ KisweDate.yearsAgo(1), new Date() ]
    }
  },
  emits: {
    'input' (_value: Date[]) { return true }
  },
  setup (props, { emit }) {
    const dateRange = computed({
      get () { return props.value },
      set (newDateRange: Date[]) {
        emit('input', newDateRange)
      }
    })
    const disabledDate = computed(() => props.disabledDate === KisweDisabledDate.None
      ? () => false
      : (date: Date) => props.disabledDate === KisweDisabledDate.BeforeNow
        ? date < KisweDate.daysAgo(1) : date > new Date()
    )
    const options = computed(() => ({ disabledDate: disabledDate.value, firstDayOfWeek: 1 }))
    return {
      dateRange,
      options
    }
  }
})
